
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
import { AuthenticationService } from '../services';
import { PermissionPolicy } from '../model';
import { AccessControlService, ResourcePermission, GetResourcePermissionsByKey } from '../access-control';
import { ValidateResourcePermissionInput } from '../security.helper';


@Injectable()
export class PermissionGuard implements CanActivate {
    constructor(private authService: AuthenticationService,
        private accessControl: AccessControlService,
        private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.authService.isAuthenticated().map((authenticated) => {
            if (!authenticated) {
                this.router.navigate(['login']);
                return false;
            }

            const rp = this.getRightConfigFromRouteData(route);

            const hasAccess = this.accessControl.HasUserAccess(rp);

            if (hasAccess) {
                return true;
            } else {
                this.router.navigate(['/no-access']);
                return false;
            }
        });
    }

    private getRightConfigFromRouteData(route: ActivatedRouteSnapshot): ResourcePermission {

        let rp = route.data['permissions'];
        if (!rp) {
            return null;
        }

        if (typeof rp === 'string') {
            rp = GetResourcePermissionsByKey(rp);
        }

        ValidateResourcePermissionInput(rp, 'RoutePermissionGuard');

        return rp;
    }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/guards/permission-guard.service.ts